import { createFileRoute } from "@tanstack/react-router";
import { createCanonicalSymbolRouteOptions } from "~/features/symbol/routing/canonical-symbol-route-options";

export const Route = createFileRoute("/_app/crypto_/$symbol")(
  createCanonicalSymbolRouteOptions("crypto"),
);
